import script from "./BeboerlistePage.vue?vue&type=script&setup=true&lang=js"
export * from "./BeboerlistePage.vue?vue&type=script&setup=true&lang=js"

import "./BeboerlistePage.vue?vue&type=style&index=0&id=1017624a&lang=scss"

const __exports__ = script;

export default __exports__